import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Please check the highlighted fields — an email looks off.";
  return d || "Something went wrong. Please try again.";
};

export const subscribe = (email) => axios.post(`${API}/subscribe`, { email });
export const sendContact = (body) => axios.post(`${API}/contact`, body);
